/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const EM_PAGE_PREVIEW_CONTENT_STRINGS = {
  '404Errors': '404 errors',
  averagePageLoadTime: 'Average page load time',
  cacheHitRatio: 'Cache hit ratio',
  cacheHitRatioTooltipText:
    'How often the website successfully loads pages quickly from stored memory, compared to the total times it tries to load any page.',
  emptyStateCaption: `There wasn't enough data to display the statistics. Please try again later, or try a different time period.`,
  emptyStateTitle: 'Data is currently being collected',
  errorMessage: 'There was a problem completing your request. Please try again later.',
  fileSize: 'File size',
  httpErrorRates: 'HTTP error rates',
  httpErrorRatesTooltipText:
    'The percentage of times the website encounters a problem when trying to display a page or complete an action, within a certain period.',
  pageLoadTime: 'Page load time',
  pageLoadTimeTooltipText:
    'How long it takes for a full webpage (HTML content) to appear on your screen after you click a link or type in an address.',
  pageViews: 'Page views',
  pageViewsTooltipText: 'The total amount of times a domain has been visited by users in the selected time period.',
  popularPages: 'Popular pages',
  totalErrors: 'Total errors',
  totalPageViews: 'Total amount of page views',
  useCustomRange: 'Use custom date range',
} as const;
